
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/pudut300",
      function () {
        return require("private-next-pages/products/pudut300.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/pudut300"])
      });
    }
  